import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import iconNotes from "@/assets/icons/notes.svg";
import iconPhone from "@/assets/icons/phone-receiver-silhouette.svg";
import iconLink from "@/assets/icons/link.svg";
import iconUser from "@/assets/icons/user.svg";
import React, { useEffect, useState } from "react";
// import { dateFormat, dateFormatDateTimeApi } from "../../../utils";
// import { useGetCounterDataMutation } from "../../../redux/reservationApi";
import { Toast } from "../../../components";

export const DashBoardCountContainer = ({ clientId, startedAt, endedAt }) => {
    // useEffect(() => {
    //     getCounterData({
    //         clientId,
    //         startedAt: startedAt && dateFormatDateTimeApi(startedAt),
    //         endedAt: endedAt && dateFormatDateTimeApi(endedAt),
    //     });
    // }, [clientId, startedAt, endedAt]);

    // const [getCounterData, { data: countData, error: countError, isLoading: countLoading }] = useGetCounterDataMutation();

    return (
        <>
            {/* {countError && <Toast visible={true} msg={countError.message}></Toast>} */}

            <section className="performance">
                <div className="section-content">
                    <div className="performance-list">
                        <div className="performance-item">
                            <div className="item-icon">
                                <img src={iconNotes} alt="" />
                            </div>
                            <div className="item-title">전체 차량 대수</div>
                            <div className="item-content">
                                <div className="item-amount">{/* <b>{countData?.data?.totalReservationCount}</b>회 */}</div>
                            </div>
                        </div>

                        <div className="performance-item">
                            <div className="item-icon">
                                <img src={iconPhone} alt="" />
                            </div>
                            <div className="item-title">운행 중 차량</div>
                            <div className="item-content">
                                <div className="item-amount">{/* <b>{countData?.data?.finishedReservationCount}</b>회 */}</div>
                            </div>
                        </div>

                        <div className="performance-item">
                            <div className="item-icon">
                                <img src={iconLink} alt="" />
                            </div>
                            <div className="item-title">대기중인 차량</div>
                            <div className="item-content">
                                <div className="item-amount">{/* <b>{countData?.data?.totalSmsCount}</b>회 */}</div>
                            </div>
                        </div>

                        <div className="performance-item">
                            <div className="item-icon">
                                <img src={iconUser} alt="" />
                            </div>
                            <div className="item-title">청구 진행 건수</div>
                            <div className="item-content">
                                <div className="item-amount">
                                    {/* <b>{countData?.data?.totalSmsCount - countData?.data?.reservedSmsCount}</b>명 */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
